<form [formGroup]="inputsFormGroup" (submit)="submitForm($event)" class="multiple-input-form">
  <h2 mat-dialog-title>{{ title }}</h2>
  <div mat-dialog-content class="dialog-content">
    @if (content) {
      <p>{{ content }}</p>
    }

    <div formArrayName="inputs">
      @for (input of inputForms.controls; track input; let i = $index) {
        @if (inputs[i].type !== 'textarea' && inputs[i].type !== 'date' && inputs[i].type !== 'select') {
          <mat-form-field [ngStyle]="{ width: inputs[i].width || '100%' }">
            <mat-label>{{ inputs[i].placeholder }}</mat-label>
            <input matInput [type]="inputs[i].type" [required]="inputs[i].required" name="i" [formControlName]="i" />
            @if (inputs[i].suffix) {
              <span matTextSuffix>
                {{ inputs[i].suffix }}
              </span>
            }
            @if (inputs[i].prefix) {
              <span matPrefix>
                {{ inputs[i].prefix }}
              </span>
            }
            @if (inputs[i].hint) {
              <mat-hint>
                {{ inputs[i].hint }}
              </mat-hint>
            }
            @if (input.hasError('required')) {
              <mat-error>
                {{ 'REQUIRED' | translate }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (inputs[i].type === 'textarea') {
          <mat-form-field [ngStyle]="{ width: inputs[i].width || '100%' }">
            <mat-label>{{ inputs[i].placeholder }}</mat-label>
            <textarea matInput rows="8" [required]="inputs[i].required" name="i" [formControlName]="i"></textarea>
            @if (inputs[i].hint) {
              <mat-hint>
                {{ inputs[i].hint }}
              </mat-hint>
            }
            @if (input.hasError('required')) {
              <mat-error>
                {{ 'REQUIRED' | translate }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (inputs[i].type === 'date') {
          <mat-form-field [ngStyle]="{ width: inputs[i].width || '100%' }">
            <input
              matInput
              [matDatepicker]="datePicker"
              (click)="datePicker.open()"
              [placeholder]="inputs[i].placeholder"
              [required]="inputs[i].required"
              name="i"
              [formControlName]="i" />
            @if (input.value) {
              <button matSuffix mat-icon-button (click)="input.reset()">
                <mat-icon>close</mat-icon>
              </button>
            }
            <!-- <button matTextSuffix mat-icon-button matTooltip="{{ 'RESET' | translate }}" *ngIf="input.value" (click)="input.reset()"> -->
            <!--     <mat-icon>close</mat-icon> -->
            <!-- </button> -->
            @if (inputs[i].hint) {
              <mat-hint>
                {{ inputs[i].hint }}
              </mat-hint>
            }
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>
        }
        @if (inputs[i].type === 'select') {
          <mat-form-field [ngStyle]="{ width: inputs[i].width || '100%' }">
            <mat-label>{{ inputs[i].placeholder }}</mat-label>
            <mat-select [formControlName]="i" [required]="inputs[i].required" [multiple]="inputs[i].multiSelect">
              @if (!inputs[i].required) {
                <mat-option value=""> –– </mat-option>
              }
              @for (item of inputs[i].options; track item) {
                <mat-option [value]="item">
                  {{ item }}
                </mat-option>
              }
            </mat-select>
            @if (input.hasError('required')) {
              <mat-error>
                {{ 'REQUIRED' | translate }}
              </mat-error>
            }
          </mat-form-field>
        }
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit">
      {{ action || ('OK' | translate) }}
    </button>
    <button mat-raised-button (click)="dialogRef.close()" type="button">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</form>
